/**
 * Utility для автогенерации slug из названия
 * Транслитерация русских букв в латиницу + timestamp для уникальности
 */

/**
 Транслитерация русских букв в латиницу
 */
const transliterate = (text: string): string => {
  const map: Record<string, string> = {
    'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
    'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
    'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
    'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
    'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
    'ш': 'sh', 'щ': 'sh', 'ъ': '', 'ы': 'y', 'ь': '',
    'э': 'e', 'ю': 'yu', 'я': 'ya',
    // Upper case variants
    'А': 'a', 'Б': 'b', 'В': 'v', 'Г': 'g', 'Д': 'd',
    'Е': 'e', 'Ё': 'e', 'Ж': 'zh', 'З': 'z', 'И': 'i',
    'Й': 'y', 'К': 'k', 'Л': 'l', 'М': 'm', 'Н': 'n',
    'О': 'o', 'П': 'p', 'Р': 'r', 'С': 's', 'Т': 't',
    'У': 'u', 'Ф': 'f', 'Х': 'h', 'Ц': 'c', 'Ч': 'ch',
    'Ш': 'sh', 'Щ': 'sh', 'Ъ': '', 'Ы': 'y', 'Ь': '',
    'Э': 'e', 'Ю': 'yu', 'Я': 'ya',
  };
  
  return text
    .toLowerCase()
    .split('')
    .map(char => map[char] || char)
    .join('')
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

/**
 * Генерация уникального slug из названия
 * Добавляет timestamp suffix для гарантии уникальности
 * 
 * @param title - Название (заголовок) для генерации slug
 * @returns Уникальный slug вида "transliterated-title-abc1"
 */
export const generateSlug = (title: string): string => {
  if (!title || title.trim().length === 0) {
    // Fallback для пустого названия
    const timestamp = Date.now().toString(36);
    return `item-${timestamp}`;
  }
  
  const base = transliterate(title.trim());
  // Timestamp в base36 (4 символа) для компактности
  const timestamp = Date.now().toString(36).slice(-4);
  
  // Ограничение длины base part (max 50 символов)
  const trimmedBase = base.length > 50 ? base.slice(0, 50) : base;
  
  return `${trimmedBase}-${timestamp}`;
};

/**
 * Генерация slug без timestamp (для редактирования существующих записей)
 * Используется когда нужно показать slug без случайной части
 * 
 * @param title - Название для генерации base slug
 * @returns Base slug без timestamp suffix
 */
export const generateBaseSlug = (title: string): string => {
  if (!title || title.trim().length === 0) {
    return 'item';
  }
  
  return transliterate(title.trim());
};